import { useContext } from 'react';
import { WebSocketContext } from '../context/socketContext';

export const useWebSocketContext = () => {
  const context = useContext(WebSocketContext);

  if (!context)
    throw new Error('useAuth must be used within a AuthContextProvider');

  return context;
};
